import {
  FlexColumn,
} from '@equifinance/shared';
import styled from 'styled-components';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';
import { useChecklistContext } from '../../../../contexts';
import { filesToChecklistDocuments } from '../../common/checklistDocument';
import DocumentItem from '../../components/DocumentItem';
import UploadDocuments from '../../../UploadDocuments';
import { usePageConfigurationContext } from '../../../../contexts/pageConfiguration';

const DocumentSectionContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[5]};
`}`;

export default function PostOfferDocumentsSection() {
  const { checklist, uploadChecklistDocuments } = useChecklistContext();
  const { postOffer } = checklist ?? {};
  const { isReadOnly: isPageReadOnly } = usePageConfigurationContext();

  const uploadingFiles = async (files: File[]) => {
    const documents = await filesToChecklistDocuments(files);
    await uploadChecklistDocuments({
      documents,
      checklistSectionId: postOffer?.id || '',
    });
  };

  return (
    <PaddedGenericSection
      title="Documents"
      subSection={ChecklistSection.POST_DOCUMENTS}
      level={1}
    >
      <DocumentSectionContainer>
        {postOffer?.documents?.map((document) => (
          <DocumentItem
            key={document.id}
            document={document}
          />
        ))}
        <UploadDocuments
          uploadingFiles={uploadingFiles}
          disabled={
            isPageReadOnly
            || postOffer?.checklistIndicatorType === 'Locked'
            || postOffer?.submitted
          }
        />
      </DocumentSectionContainer>
    </PaddedGenericSection>
  );
}
